import { INVALID_CURRENT_PASSWORD_ERROR } from "./error-codes.constants";
import ApiError from "../../errors/ApiError";

export class InvalidCurrentPasswordError extends ApiError {
  constructor() {
    super(INVALID_CURRENT_PASSWORD_ERROR);
  }
}
